import Axios from "axios";

export default class Request{
    static backend = 'http://localhost:1234/wp-json/wp/v2/';
    static make(method,endpoint,data = {}){
        // let token = localStorage.getItem('token'); 
        let token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6IjZlZDMwNjVlZjc0NjAwMGY0N2RlYWI1ZmUwNzFkNDg5MTAwYTVjODc2OTUxNTY4ZmE5ZmU4Y2U1NWMyN2MyZTMxNzY1NjM5MDU4NzA1ZmMxIn0.eyJhdWQiOiI2IiwianRpIjoiNmVkMzA2NWVmNzQ2MDAwZjQ3ZGVhYjVmZTA3MWQ0ODkxMDBhNWM4NzY5NTE1NjhmYTlmZThjZTU1YzI3YzJlMzE3NjU2MzkwNTg3MDVmYzEiLCJpYXQiOjE1NjQ3MjkzOTAsIm5iZiI6MTU2NDcyOTM5MCwiZXhwIjoxNTk2MzUxNzkwLCJzdWIiOiIyIiwic2NvcGVzIjpbXX0.D5dq9t9N5j4qcGZ9noS9Wg5xnEZaIctuz4Ohsuum5QWU2zMdoFRwehtkpIOcIwvPcLxntwxHw5M9mHHEyu_mASa6qgJlpDubrl9t86nfPZYcoBazJvNrmB7Qqcz1FY1Y4TvpvUO55vwPiGtjxVd9s50baAjUUtXzTe631LFPofoYMIlWNP6EgHBaSBmY1QpyharC5eWCdpelltzie0vdOvY-zRL2NVChHn6cv-pEmB6wVWZqXlUMz-bUe6z7mHTRcOCukjq0NnGwa-EeYyr-DDE5FM8Rl7WcMDJkZ8GvphkucFZB4jfQTBQwCnHacZGGDTipv_3ax7ULSEoqiUbt-3zWN12VFHnkJdyP6Xn9iPvbLZIAIWlkNRtF7i4H9dkoxoFp6bkXOAY2bRbcxeuHQ3oaXmB82JOoYpqGphGAPdY_dYSHZNv4zgsLxowFVYpWzu1vTx7hRNZNlQ53kOukGWTeLG6HBvG4Ei1pn66oP4pqPRK9sBmvWlT1MxsaXiANPe4KX9OlCkvpiiT8QY4feMXi4G3KiqksTjMbxBi41TRRNd7xtcC5WWtqSi6IyYccs_k9J2_z2Nikjy8ftWFc8zlpmZMt2kZUJi_9BcECxrKhchomUzlYeuVPwc0NIIpLv8KU7xDuY5z6vrWX8LVQ_F4RI3e5kSnzZquqQWeBsfA';
        let header = {
            // 'content-type': 'multipart/form-data',
        };
        if(token !== null){
            token = token.replace('"','');
            header['Authorization'] = `Bearer ${token}`;
        }
        data.endpoint = endpoint;
        data.method = method;

        return Axios({
            method : method,
            url : `${this.backend}${endpoint}`,
            data : data,
            // headers: header
        })
    }
}